import React, { FC, useEffect, useState } from "react";
import { generatePath, useHistory, useLocation } from "react-router";
import { STUDENT_ANALYTICS_EXERCISES_LIST } from "../../../../routes/routeConstants/appRoutes";
import ChapterService from "../../../../services/CourseServices/ChapterService/chapter.service";
import AppHeader from "../../../../shared/components/AppHeader";
import ListAnalyticsSubjectCards from "../ListAnalyticsSubjectCards";
const ListAnalyticsChapterCards: FC = () => {
  const [chapters, setChapters] = useState<any[]>([]);
  const history = useHistory();
  const { state }: { state: any } = useLocation();
  const fetchChapters = (searchString?: string) => {
    let queryParams = `?class_room_subject_id=${state?.subjectId}&search=${
      searchString || ""
    }`;
    ChapterService.getChaptersList(
      queryParams,
      (chapters: any) => {
        setChapters([...chapters]);
      },
      () => {},
      () => {}
    ).then();
  };

  useEffect(() => {
    fetchChapters();
  }, []);

  return (
    <div className="page-view">
          <AppHeader
        headerText={state?.subjectName}
        showSearch={false}
        showButton={false}
        showBreadCrumb={false}
        showFilter={false}
        buttonIcon={null}
        showBack
      />
      <ListAnalyticsSubjectCards
        showProgress
        subjects={chapters}
        onClick={(id, name) => {
            history.push({
                pathname: generatePath(STUDENT_ANALYTICS_EXERCISES_LIST, {studentId: 1, subjectId: state?.subjectId, chapterId: id}),
                state: {...state, chapterId: id, chapterName: name}
            })
        }}
      />
    </div>
  );
};
export default ListAnalyticsChapterCards;
